import Vue from "vue";
import PictureUploader from "../../components/PictureUploader.vue";
import { SelectOption, SelectOptionKey } from "resources/assets/types";

const instantTutorChoices: SelectOption[] = [
  {
    key: "yes",
    value: 1,
    label: "Yes Instant Tutor"
  },
  {
    key: "no",
    value: 0,
    label: "No Instant Tutor"
  }
];

export const PageComponent = Vue.extend({
  props: {
    initialIsInstantTutor: {
      type: Boolean,
      required: false
    },
    initialIntro: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      isInstantTutor: this.initialIsInstantTutor || 0,
      instantTutorChoices,
      intro: this.initialIntro || ""
    };
  },

  computed: {
    isValid(): boolean {
      return this.intro.trim().length > 0;
    },
    instantTutorKey(): SelectOptionKey {
      return (
        instantTutorChoices.find(c => c.value === this.isInstantTutor)?.key ||
        "no"
      );
    }
  },

  methods: {
    updateInstantTutor(key: SelectOptionKey) {
      this.isInstantTutor =
        instantTutorChoices.find(choice => choice.key === key)?.value || 0;
    },
    updateIntro(value: string) {
      this.intro = value.trim();
    }
  },

  components: {
    PictureUploader
  }
});
